import request from '@/utils/request'

export function updateActivityObject(data) {
    return request({
        url: '/backend/activity/updateActivityObject',
        method: 'post',
        data: data
    })
}

export function createActivityObject(data) {
    console.log(data);
    return request({
        url: '/backend/activity/createActivityObject',
        method: 'post',
        data: data
    })
}

export function deleteActivityObject(data) {
    return request({
        url: '/backend/activity/deleteActivityObject',
        method: 'post',
        data: data
    })
}

export function activityObjectList(data) {
    return request({
        url: '/backend/activity/activityObjectList',
        method: 'post',
        data: data
    })
}

export function getActivityObjectInfo(data) {
    return request({
        url: '/backend/activity/getActivityObjectInfo',
        method: 'post',
        data: data
    })
}

export function getMentorRegisterList(data) {
    return request({
        url: '/backend/activity/getMentorRegisterList',
        method: 'post',
        data: data
    })
}
export function setActivityPromotion(data) {
    return request({
        url: '/backend/activity/setActivityPromotion',
        method: 'post',
        data: data
    })
}

export function aliyunOssToken(data) {
    return request({
        url: '/backend/common/aliyunOssToken',
        method: 'post',
        data: data
    })
}

export function getActivityObjectVideoList(data) {
    return request({
        url: '/backend/activity/getActivityObjectVideoList',
        method: 'post',
        data: data
    })
}

//创建活动
export function createMeetActivity(data) {
    return request({
        url: '/backend/activity/createMeetActivity',
        method: 'post',
        data: data
    })
}
//更新活动
export function updateMeetActivity(data) {
    return request({
        url: '/backend/activity/updateMeetActivity',
        method: 'post',
        data: data
    })
}
//获取单个活动信息
export function getMeetActivityInfo(data) {
    return request({
        url: '/backend/activity/meetActivityInfo',
        method: 'post',
        data: data
    })
}
//获取活动列表
export function getMeetActivityList(data) {
    return request({
        url: '/backend/activity/meetActivityList',
        method: 'post',
        data: data
    })
}
//删除活动
export function deleteActivity(data) {
    return request({
        url: '/backend/activity/activityListDelete',
        method: 'post',
        data: data
    })
}
//遇见签到二维码
export function meetActivityQrcode(data) {
    return request({
        url: '/backend/activity/meetActivityQrcode',
        method: 'post',
        data: data
    })
}
//活动上下架
export function meetActivitySet(data) {
    return request({
        url: '/backend/activity/meetActivitySet',
        method: 'post',
        data: data
    })
}

//获取活动关联课程列表
export function meetRelationCourse(data) {
    return request({
        url: '/backend/activity/meetRelationCourse',
        method: 'post',
        data: data
    })
}

//活动关联课程
export function createRelationCourse(data) {
    return request({
        url: '/backend/activity/createRelationCourse',
        method: 'post',
        data: data
    })
}
//搜索课程
export function relationCourseChoice(data) {
    return request({
        url: '/backend/activity/relationCourseChoice',
        method: 'post',
        data: data
    })
}
//活动删除关联课程
export function relationCourseDelete(data) {
    return request({
        url: '/backend/activity/relationCourseDelete',
        method: 'post',
        data: data
    })
}
//获取关联课程二维码
export function relationCourseQrcode(data) {
    return request({
        url: '/backend/activity/relationCourseQrcode',
        method: 'post',
        data: data
    })
}

//组长列表
export function meetGroupList(data) {
    return request({
        url: '/backend/activity/meetGroupList',
        method: 'post',
        data: data
    })
}
//创建组
export function createMeetGroup(data) {
    return request({
        url: '/backend/activity/createMeetGroup',
        method: 'post',
        data: data
    })
}
//编辑组
export function updateMeetGroup(data) {
    return request({
        url: '/backend/activity/updateMeetGroup',
        method: 'post',
        data: data
    })
}
//组长列表删除
export function groupListDelete(data) {
    return request({
        url: '/backend/activity/groupListDelete',
        method: 'post',
        data: data
    })
}
//导入小组
export function importGroupList(data) {
    return request({
        url: '/backend/activity/importGroupList',
        method: 'post',
        data: data
    })
}

export function getMeetActivityOrderList(data) {
    return request({
        url: '/backend/activity/getMeetActivityOrderList',
        method: 'post',
        data: data
    })
}
export function getMeetActivityCourseList(data) {
    return request({
        url: '/backend/activity/getMeetActivityCourseList',
        method: 'post',
        data: data
    })
}
export function getMeetActivityStat(data) {
    return request({
        url: '/backend/activity/getMeetActivityStat',
        method: 'post',
        data: data
    })
}
export function exportMeetActivityOrder(data) {
    return request({
        url: '/backend/activity/exportMeetActivityOrder',
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

//学员列表
export function meetStudentList(data) {
    return request({
        url: '/backend/activity/meetStudentList',
        method: 'post',
        data: data
    })
}

//幸福之旅学员列表
export function meetXfStudentList(data) {
    return request({
        url: '/backend/activity/meetXfStudentList',
        method: 'post',
        data: data
    })
}
//添加学员(幸福之旅学员列表)
export function importOrderToGroupXf(data) {
    return request({
        url: '/backend/activity/importOrderToGroupXf',
        method: 'post',
        data: data
    })
}
//幸福之旅导入学员
export function importStudentListXf(data) {
    return request({
        url: '/backend/activity/importStudentListXf',
        method: 'post',
        data: data
    })
}

//添加学员
export function createMeetStudent(data) {
    return request({
        url: '/backend/activity/importOrderToGroup',
        method: 'post',
        data: data
    })
}
//导入学员
export function importStudentList(data) {
    return request({
        url: '/backend/activity/importStudentList',
        method: 'post',
        data: data
    })
}
//缺席出席
export function studentListSet(data) {
    return request({
        url: '/backend/activity/studentListSet',
        method: 'post',
        data: data
    })
}
//删除学员
export function studentListDelete(data) {
    return request({
        url: '/backend/activity/studentListDelete',
        method: 'post',
        data: data
    })
}
//清空学员列表
export function delAllStudent(data) {
    return request({
        url: '/backend/activity/delAllStudent',
        method: 'post',
        data: data
    })
}
//设置分组
export function meetGrouping(data) {
    return request({
        url: '/backend/activity/meetGrouping',
        method: 'post',
        data: data
    })
}
//线下遇见的复训学员学费返现
export function relationStudentRefundYWEGIRIP (data) {
    return request({
        url: '/backend/activity/relationStudentRefundYWEGIRIP',
        method: 'post',
        data: data
    })
}
export function relationStudentMultiRefundYWEGIRIP (data) {
    return request({
        url: '/backend/activity/relationStudentMultiRefundYWEGIRIP',
        method: 'post',
        data: data
    })
}


//线下遇见幸福之旅的学员代理商核销分润（单个）
export function relationStudentCancelShare (data) {
    return request({
        url: '/backend/activity/relationStudentCancelShare',
        method: 'post',
        data: data
    })
}
//线下遇见幸福之旅的学员代理商核销分润（批量）
export function relationStudentMultiCancelShare (data) {
    return request({
        url: '/backend/activity/relationStudentMultiCancelShare',
        method: 'post',
        data: data
    })
}

//查询区长和组长
export function statisticsScreen(data) {
    return request({
        url: '/backend/statistics/statisticsScreen',
        method: 'post',
        data: data
    })
}

//更改组长、区长所属部门
export function updateGroupOrParentDepartment(data) {
    return request({
        url: '/backend/activity/updateGroupOrParentDepartment',
        method: 'post',
        data: data
    })
}

export function getActivityLodgingItemList(data) {
    return request({
        url: '/backend/activity/getActivityLodgingItemList',
        method: 'post',
        data: data
    })
}
export function setActivityLodgingItem(data) {
    return request({
        url: '/backend/activity/setActivityLodgingItem',
        method: 'post',
        data: data
    })
}
export function delActivityLodgingItem(data) {
    return request({
        url: '/backend/activity/delActivityLodgingItem',
        method: 'post',
        data: data
    })
}

export function getInviteInfo(data) {
    return request({
        url: '/backend/activity/getInviteInfo',
        method: 'post',
        data: data
    })
}
export function setInviteInfo(data) {
    return request({
        url: '/backend/activity/setInviteInfo',
        method: 'post',
        data: data
    })
}